import React from "react";

export default function Card(props) {

    const { header = "", style={}, secondary=false } = props;

    let _card_class = (!secondary) ? "ui-card" : "ui-card secondary";
    let _card_header_class = (!secondary) ? "ui-card-header" : "ui-card-header secondary";
    let _card_content_class = (!secondary) ? "ui-card-content" : "ui-card-content secondary";

    return (
        <div style={{...style}} className={_card_class}>
            
            {(header &&
                <div className={_card_header_class}>
                    {header}
                </div>
            )}

            <div className={_card_content_class}>
                {props.children}
            </div>
        </div>
    )
}